import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

export interface ApiResponse {
  success: true;
  url: string;
  returnUrl: string;
}
export interface Params {
  priceId: string;
  isTrialMode?: boolean;
  userCount: number;
  isAnnual: boolean;
  isCouponApplied?: boolean;
  billingCountry: BillingCountry;
  preferredBillingCountry: AvailableCountries;
}

/**
 * React Query hook to fetch all the available useCheckout for the user from stripe
 * @returns ApiResponse | undefined
 */
const useCheckout = ({
  priceId,
  isTrialMode,
  userCount,
  isAnnual,
  isCouponApplied,
  billingCountry,
  preferredBillingCountry,
}: Params) => {
  const { orgId } = useAuth();
  return useQuery({
    queryKey: [Query.StripeKeys.checkoutSession],
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    enabled: false,
    queryFn: async () => {
      const response = await axios.post<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/checkout`, {
        price: priceId,
        orgId,
        isTrialMode,
        userCount,
        isAnnual,
        isCouponApplied,
        billingCountry,
        preferredBillingCountry,
      });
      return response.data;
    },
  });
};

export { useCheckout };
